import React, { useEffect, useState } from "react";
import { Divider, Pagination } from "antd";
import "./Resources.css";
import BIDButton from "../../components/reusable/BIDButton/BIDButton";
import ArticleCard from "../../components/reusable/ArticleCard/ArticleCard";
import labResources from "../../utils/resources/labsObs.json";
import academicResources from "../../utils/resources/academic.json";
import bidResources from "../../utils/resources/bid.json";
import bidResourcesEn from "../../utils/resources/bid_en.json";
import campaginResources from "../../utils/resources/campaigns.json";
import metricsResources from "../../utils/resources/metrics.json";
import SearchTag from "../../components/reusable/SearchTag/SearchTag";
import { useCurrentLanguage } from "../../hooks/useCurrentLanguage";
import TEXT from "../../utils/text/resources.json";
import TEXT_MISC from "../../utils/text/misc.json";

const items = [
  {
    key: "bid",
  },
  {
    key: "academic",
  },
  {
    key: "labs",
  },
  // {
  //   key: "campaigns",
  // },
  {
    key: "metrics",
  },
];

export default function Resources() {
  const { language } = useCurrentLanguage();
  const [currentMenuItem, setCurrentMenuItem] = useState("bid");
  const [currentListOfResources, setCurrentListOfResources] = useState(
    bidResources.sort((a, b) => b.year - a.year)
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchWords, setSearchWords] = useState([]);
  const [inputText, setInputText] = useState("");

  const handleClick = (key) => {
    setCurrentMenuItem(key);
  };

  const handlePaginationChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
    window.scrollTo({ top: 100, left: 0, behavior: "smooth" });
  };

  const handleDeleteTag = (text) => {
    const newSearchArray = searchWords;
    const toDeleteIndex = newSearchArray.indexOf(text);
    newSearchArray.splice(toDeleteIndex, 1);

    const newResources = getListOfResources(currentMenuItem, newSearchArray);
    setSearchWords(newSearchArray);
    setCurrentListOfResources(newResources);
  };

  const handleInputChange = (event) => {
    event.preventDefault();
    setInputText(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") handleSearch();
  };

  const handleSearch = () => {
    if (!searchWords.includes(inputText) && inputText.trim() !== "") {
      const newSearchWordsArray = searchWords;
      newSearchWordsArray.push(inputText);
      setSearchWords(newSearchWordsArray);

      const newListOfResources = getListOfResources(
        currentMenuItem,
        newSearchWordsArray
      );

      setCurrentListOfResources(newListOfResources);
    }

    setInputText("");
  };

  const getListOfResources = (type, search) => {
    let resources;

    switch (type) {
      case "bid":
        resources = language === 'es' ? bidResources : bidResourcesEn;
        break;
      case "academic":
        resources = academicResources;
        break;
      case "labs":
        resources = labResources;
        break;
      case "campaigns":
        resources = campaginResources;
        break;
      case "metrics":
        resources = metricsResources;
        break;
      default:
        resources = [];
        break;
    }

    resources = resources.sort((a, b) => b.year - a.year);

    if (search.length > 0) {
      search.forEach((word) => {
        word = word
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");

        resources = resources.filter((article) => {
          let matchInText = false;

          matchInText = article.title
            ? article.title
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .includes(word) || matchInText
            : matchInText;

          matchInText = article.description
            ? article.description
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .includes(word) || matchInText
            : matchInText;

          matchInText = article.region
            ? article.region
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .includes(word) || matchInText
            : matchInText;

          matchInText = article.country
            ? article.country
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .includes(word) || matchInText
            : matchInText;

          return matchInText;
        });
      });
    }

    return resources;
  };

  useEffect(() => {
    const listOfResources = getListOfResources(currentMenuItem, searchWords);

    setCurrentListOfResources(listOfResources);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentMenuItem]);

  useEffect(() => {
    setCurrentPage(1);
  }, [currentListOfResources]);

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    window.dataLayer.push({
      event: 'pageview'
    });
  }, []);

  return (
    <div className="rp-container">
      <div className="rp-title-section">
        <h1 className="rp-title-text">{TEXT["pageTitle"][language]}</h1>
      </div>
      <div className="rp-menu">
        {items.map((i) => {
          return (
            <button
              key={i.key}
              className={
                "rp-menu-item" +
                (currentMenuItem === i.key ? " rp-menu-selected" : "")
              }
              onClick={() => handleClick(i.key)}
            >
              <span>{TEXT[i.key][language]}</span>
            </button>
          );
        })}
      </div>
      <Divider className="divider-full-screen" />
      <div className="rp-search-form">
        <input
          className="rp-search-input"
          placeholder={TEXT_MISC["searchInput"][language]}
          value={inputText}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
        />
        <BIDButton
          text={TEXT_MISC["searchButton"][language]}
          type="dark"
          size="medium"
          onClick={handleSearch}
        />
      </div>
      <div className="rp-search-words">
        {searchWords.map((word, key) => {
          return (
            <SearchTag key={key} text={word} deleteTag={handleDeleteTag} />
          );
        })}
      </div>
      <div className="rp-pagination">
        <Pagination
          current={currentPage}
          pageSize={pageSize}
          responsive={true}
          total={currentListOfResources.length}
          onChange={handlePaginationChange}
          hideOnSinglePage={currentListOfResources.length === 0}
        />
      </div>
      <div className="rp-content">
        {currentListOfResources.length > 0 ? (
          currentListOfResources
            .slice(currentPage * pageSize - pageSize, currentPage * pageSize)
            .map((article, key) => (
              <div key={key} className="rp-content-card">
                <ArticleCard
                  title={article.title ?? ""}
                  author={article.author ?? ""}
                  date={article.year ?? ""}
                  tags={article.tags ?? []}
                  description={article.description ?? ""}
                  articleURL={article.url ?? ""}
                  imageURL={
                    article.imageName
                      ? currentMenuItem + "/" + article.imageName
                      : ""
                  }
                  imageAltText={article.imageAltText ?? ""}
                  isLinkInternal={false}
                  language={language}
                />
              </div>
            ))
        ) : (
          <div className="rp-no-articles">{TEXT["nonFound"][language]}</div>
        )}
      </div>
      <div className="rp-pagination">
        <Pagination
          current={currentPage}
          pageSize={pageSize}
          responsive={true}
          hideOnSinglePage={currentListOfResources.length === 0}
          total={currentListOfResources.length}
          onChange={handlePaginationChange}
        />
      </div>
    </div>
  );
}
